<script setup lang="ts">
import { useAppConfigStore } from '../stores/app-config-store';
import { useAppLayoutStateStore } from '../stores/app-layout-state';
import { useRouter } from 'vue-router';
import AppMenu from './AppMenu.vue';
import AppLogo from './AppLogo.vue';

const appConfig = useAppConfigStore();
const appState = useAppLayoutStateStore();
const { push } = useRouter();

let timeout: ReturnType<typeof setTimeout> | null = null;

function mouseEnterHandler() {
    if (!appConfig.sidebarAnchored) {
        if (timeout) {
            clearTimeout(timeout);
            timeout = null;
        }
        appState.sidebarActive = true;
    }
}

function mouseLeaveHandler() {
    if (!appConfig.sidebarAnchored) {
        if (!timeout) {
            if (appConfig.hideSidebarTimeout > 0) {
                timeout = setTimeout(
                    () => (appState.sidebarActive = false),
                    appConfig.hideSidebarTimeout
                );
            } else {
                appState.sidebarActive = false;
            }
        }
    }
}

function anchorClickHandler() {
    appConfig.toggleSidebarAnchored();
}

function navigateToDashboard() {
    push('/dashboard');
}
</script>

<template>
    <div
        class="layout-sidebar"
        @mouseenter="mouseEnterHandler"
        @mouseleave="mouseLeaveHandler"
    >
        <div class="sidebar-header">
            <a class="app-logo cursor-pointer" @click="navigateToDashboard">
                <AppLogo :full="appState.fullLogo" height="2.1rem" />
            </a>
            <button
                class="layout-sidebar-anchor p-link"
                type="button"
                @click="anchorClickHandler"
            ></button>
        </div>

        <div ref="menuContainer" class="layout-menu-container">
            <AppMenu />
        </div>
    </div>
</template>
